import { getTargetUrlAndAccessToken } from '../login/accessTokens'
import { getSyncTarget } from './getSyncTarget'
import { getLibraryToSync } from './getLibraryToSync'
import { getCCLClient } from '../../getCCLClient'
import { ensureLibraryExistsOnTarget } from './ensureLibraryExistsOnTarget'
import { syncRevisions } from './syncRevisions'
import { ArgumentsCamelCase } from 'yargs'
import { CustomComponentLibraryWrappedClient } from '../../customComponentLibraryWrappedClient'

export async function syncCommand(argv: ArgumentsCamelCase<{ 'unix-socket': boolean, verbose?: boolean, header?: string[], 'target-header'?: string[], 'url'?: string, 'access-token'?: string, 'path-to-unix-socket'?: string, 'target-url'?: string, 'target-access-token'?: string, 'target-path-to-unix-socket'?: string }>) {
  const askForUnixSocket = argv['unix-socket']
  const headers = argv['header']
  const targetHeaders = argv['target-header']
  const url = argv['url']
  const accessToken = argv['access-token']
  const pathToUnixSocket = argv['path-to-unix-socket']
  const targetUrl = argv['target-url']
  const targetAccessToken = argv['target-access-token']
  const targetPathToUnixSocket = argv['target-path-to-unix-socket']

  if(!url && !accessToken) {
    const defaultUrlAndAccessToken = getTargetUrlAndAccessToken()
    if (defaultUrlAndAccessToken) {
      console.log(
      `You are logged into ${defaultUrlAndAccessToken.url}, this command will copy from that instance. If you would like to use another instance, login into that instance with \`retool-ccl login\` first`,
    )
  } else {
    console.log('You are not logged in. Use `npx retool-ccl login` first')
    return
  }
}

  const originClient = await getCCLClient(askForUnixSocket, headers, 'default', url, accessToken, pathToUnixSocket, argv.verbose || false)

  let targetClient: CustomComponentLibraryWrappedClient
  if(targetUrl && targetAccessToken) {
    targetClient = await getCCLClient(askForUnixSocket, targetHeaders, 'sync-target', targetUrl, targetAccessToken, targetPathToUnixSocket, argv.verbose || false)
  } else{
    const targetUrl = await getSyncTarget(askForUnixSocket, targetHeaders ?? [])
    targetClient = await getCCLClient(askForUnixSocket, targetHeaders, targetUrl, undefined, undefined, targetPathToUnixSocket, argv.verbose || false)
  }

  const libraryId = await getLibraryToSync(originClient)

  await ensureLibraryExistsOnTarget(libraryId, originClient, targetClient)

  await syncRevisions(libraryId, originClient, targetClient, argv.verbose || false)
}
